/**
 * Created by Boris on 16/02/2017.
 */
export class RefDataItem {
  constructor(public id: number|string, public display: string) {
  }
}

export enum RefDataType {
  StreetTypes,
  StreetSuffixes,
  UnitTypes,
  Titles,
  ApplicationTypes,
  Municipalities,
  States,
  Zones,
  Consultants,
  FloorTypes,
  SRAWaterSupplyPurpose,
  SRAPumpCurveType,
  SRAServiceSize,
  CMPTappingandMeterSize,
  MFMeterSize
}



// WEBPACK FOOTER //
// ./src/app/shared/data-objects/ref-data-item.ts